import {
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  SPACING,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

interface BnplInfoRowProps {
  color: string;
  text: string;
  linkText: string;
  onLinkClick: () => void;
  linkTestId: string;
  className?: string;
}

export const BnplInfoRow: React.FC<BnplInfoRowProps> = ({
  color,
  text,
  linkText,
  onLinkClick,
  linkTestId,
  className,
}) => (
  <Row className={className} style={{color}}>
    <IconWrapper>
      <Icon asset={GenericIconName.InfoOutline} size="SS" fill={color} />
    </IconWrapper>
    <TextWrapper>
      <InfoText>{text}</InfoText>
      <InfoLink onClick={onLinkClick} type="button" data-testid={linkTestId}>
        {linkText}
      </InfoLink>
    </TextWrapper>
  </Row>
);

const Row = styled.div`
  display: flex;
  gap: ${SPACING['Y.Sm']};
  align-items: flex-start;
`;

const IconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING['Y.Sm']};
  padding-top: ${SPACING['Y.Xs']};
`;

const InfoText = styled.p`
  font-size: 13px;
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 1.2;
  color: inherit;
  letter-spacing: -0.26px;
  margin: 0;
`;

const InfoLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: 1.2;
  color: inherit;
  letter-spacing: -0.26px;
  text-decoration: underline;
  text-align: left;
`;
